'use client';

export const config = {
    defaultData: {
        id: '', // 活动id
        backgroundColor: 'linear-gradient(85deg, #F6E7C0 27.33%, #EAD08E 73.13%)',
        titleColor: '#18191B',
        subTitleColor: '#18191B',
        themeColor: '#000',
        showListBtn: 'N',
        listBtnColor: '#000',
        listBtnFontColor: '#fff',
        showRewardsBtn: 'N',
        rewardsBtnColor: '#000',
        rewardsBtnFontColor: '#000',
        /** 外层圆环 */
        bgImage: 'https://websiteoss.ecoflow.com/figma-uploads/1772700598331-uwjrhd-compressed-Group%201612707937.png',
        /** 中间按钮 */
        btnImage: 'https://websiteoss.ecoflow.com/figma-uploads/1772700614805-mqhghh-compressed-Frame%20161270229.png',
        /** 中间按钮置灰 */
        btnDisabledImage: 'https://websiteoss.ecoflow.com/figma-uploads/1772700625872-h91t2m-compressed-Frame%202094655010.png',
        prizeFontColor: '#000',
        // prizeBgColor1: '#FEFCF8',
        // prizeBgColor2: '#F9F1DD',
        // prizeBgColor3: '',
        loginType: 'modal',
    },
};

export type DicType = {
    label?: string | number;
    value: string | undefined;
};

export const OtherOpthions: DicType[] = [
    {
        value: '_others',
        label: '自定义',
    },
];

export const GrayOpthions: DicType[] = [
    {
        value: 'linear-gradient(85deg, #F6E7C0 27.33%, #EAD08E 73.13%)',
        label: '金色渐变',
    },
    {
        value: '#F3F4F7',
        label: '灰色',
    },
    ...OtherOpthions,
];

export const BGColorOpthions: DicType[] = [
    {
        value: 'linear-gradient(85deg, #F6E7C0 27.33%, #EAD08E 73.13%)',
        label: '金色渐变',
    },
    ...OtherOpthions,
];

export const BlackOpthions: DicType[] = [
    {
        value: '#18191B',
        label: '深灰色',
    },
    {
        value: '#000',
        label: '黑色',
    },
    {
        value: '#FEFCF8',
        label: '米白色',
    },
    {
        value: '#F9F1DD',
        label: '浅黄色',
    },
    ...OtherOpthions,
];

export const btnColorOptions: DicType[] = [
    {
        value: '#000',
        label: '黑色',
    },
    {
        value: '#fff',
        label: '白色',
    },
    ...OtherOpthions,
];

export const mianTitleColorOptions: DicType[] = [
    {
        value: '#000',
        label: '黑色',
    },
    ...OtherOpthions,
];

export const themeColorOptions: DicType[] = [
    {
        value: '#000',
        label: '黑色',
    },
    ...OtherOpthions,
];